<template>
    <div>
      <el-dialog :close-on-click-modal="false"
      :title="titleType"
      :visible.sync="addFlow"
      width="546px"
      :before-close="addProHandleClose"
      center
    >
      <div class="addDk">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
          <el-form-item label="名称：" prop="stall">
            <el-input v-model="ruleForm.stall" maxlength="15"></el-input>
          </el-form-item>
          <el-form-item label="档口登录账号：" prop="account">
            <el-input v-model="ruleForm.account" maxlength="6"></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="pwd">
            <el-input v-model="ruleForm.pwd"  maxlength="12"  type="password"></el-input>
          </el-form-item>
          <el-form-item label="二次确认密码：" prop="sure_pwd">
            <el-input v-model="ruleForm.sure_pwd" maxlength="12" type="password"></el-input>
          </el-form-item>
          <span class="notes">注：数字与字母组合不超过12位</span>
          <el-form-item label="餐厅：" >
            <el-select v-model="ruleForm.rid" placeholder="请选择餐厅" clearable>
              <el-option
                v-for="item in option"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <span class="notes">注：6位</span> -->
        </el-form>
        <div class="addBtns">
            <!-- <div>重置</div> -->
            <div @click="add('ruleForm')">确认保存</div>
        </div>
      </div>
    </el-dialog>
    </div>  
</template>
<script>
import {StallAdd,StallUpdate} from '@/request/scenic.js'
import {Message} from 'element-ui'
export default{
  props:['option'],
  data(){
    return{
      ruleForm: {
          token:window.sessionStorage.getItem('Token'),
          stall: '',
          account:'',
          pwd:'',
          rid:'',
          sure_pwd:''
      },
      rules: {
        stall: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' },
        ],
        sure_pwd:[
          { required: true, trigger: "blur", message: "请输入二次确认密码" },
        ],
        pwd: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
        ],
        rid:[{ required: true, message: '请选择餐厅', trigger: 'change'}]
      },
      addFlow:false,
      titleType:''
    }
  },
  methods:{
    pxFn(row){
      if(row){
        this.titleType = '修改档口'
        this.ruleForm = {
          token:window.sessionStorage.getItem('Token'),
          stall:row.stall,
          account:row.account,
          pwd:row.pwd,
          id:row.id,
          rid:row.rid,
          sure_pwd:row.pwd
        }
      }else{
        this.titleType = '添加档口'
      }
      this.addFlow = true
    },
    addProHandleClose(){
      this.addFlow = false
      this.$emit('close')
    },
    add(ruleForm){
      if(!this.ruleForm.rid){
        Message.error('请选择餐厅')
        return false
      }
      this.$refs.ruleForm.validate((valid)=>{
          if(valid){
            if(this.ruleForm.id){
              StallUpdate(this.ruleForm).then(res=>{
                if(res.data.status=='ok'){
                  this.addFlow = false
                  this.$emit('close')
                  Message.success('修改档口成功')
                  this.ruleForm={
                      token:window.sessionStorage.getItem('Token'),
                      stall: '',
                      account:'',
                      pwd:'',
                      id:''
                  }
                }else{
                  Message.error(res.data.msg)
                }
              })
            }else{
              StallAdd(this.ruleForm).then(res=>{
              if(res.data.status=='ok'){
                this.addFlow = false
                this.$emit('close')
                Message.success('添加档口成功')
                this.ruleForm={
                    token:window.sessionStorage.getItem('Token'),
                    stall: '',
                    account:'',
                    pwd:'',
                }
              }else{
                Message.error(res.data.msg)
              }
            })
            }
          }else{
            return
          }
      })
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .el-table__header th,::v-deep .el-table td{
  text-align: left !important;
}

::v-deep .el-dialog__body{
  padding: 0 2rem 2rem 2rem !important;
}
.notes{
  margin-left: 120px;
  margin-top: 2rem;
  display: block;
  color: #E74C3C;
  font-size: 1.4rem;
}
::v-deep .el-form-item{
  margin-bottom: 0 !important;
  margin-top: 2rem;
}
.addBtns{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3.8rem;
  >div{
    width: 10rem;
    height: 4rem;
    border-radius: 4px;
    line-height: 4rem;
    text-align: center;
    font-size: 1.4rem;
    color: #fff;
    cursor: pointer;
      background: #246DEB;
  }
}
</style>